const PADDING = "000000";

export function transformValueAndCurrency(value: number | string | undefined,
                                          activeLang: string,
                                          currencyLabel: string = "",
                                          fractionSize: number = 2,
                                          symbol: boolean = false,
                                          currencySymbol: string = ""): string  {
    const DOT_SEPARATOR = ".";
    const COMMA_SEPARATOR = ",";

    const decimalSeparator = activeLang === "en" ? DOT_SEPARATOR : COMMA_SEPARATOR;
    const thousandsSeparator = activeLang === "en" ? COMMA_SEPARATOR : DOT_SEPARATOR;
    const curr = symbol ? currencySymbol : currencyLabel;
    if (value || value === 0) {
        let [integer, fraction = ""] = value.toString().split(DOT_SEPARATOR);

        fraction = fractionSize > 0
            ? decimalSeparator + (fraction + PADDING).substring(0, fractionSize)
            : "";

        integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);

        const transformed = `${symbol ? curr ?? '' : ''}${integer}${fraction} ${symbol ? '' : curr ?? ''}`;
        return transformed.trim();
    } else {
        return "-";
    }
}